import type { App } from "vue";
import router from "@/router";
import pinia from "@/plugins/pinia";
import head from "@/plugins/vue-head";

import matomo from "vue-matomo";

const analytic = {
  host: import.meta.env.VITE_MATOMO_HOST!,
  id: Number(import.meta.env.VITE_MATOMO_WEBSITE_ID),
};

export function registerPlugins(app: App) {
  app.use(router).use(head).use(pinia).use(matomo, {
    host: analytic.host,
    siteId: analytic.id,
    trackerFileName: "matomo",
    router,
    enableLinkTracking: true,
    requireConsent: true,
    requireCookieConsent: true,
    trackInitialView: false,
  });
}
